import React, { Component } from "react";
import { func } from "prop-types";
import { Col, Row } from "react-bootstrap";
import moment from "moment";

import { push } from "connected-react-router";
import { Field, Form, withFormik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { compose } from "redux";
import { DateRangeField } from "pages/_components/fields/DateRangeField";

import { actions as transactionsActions, selectors as transactionsSelectors } from "reducers/transactions";

import Button from "pages/_components/Button";

import * as i18n from "util/i18n";

const FORM_ID = "transactions.list.filters.period";

class PeriodFilter extends Component {
    static propTypes = {
        setFieldValue: func.isRequired,
    };

    hadleClear = () => {
        const { setFieldValue } = this.props;
        setFieldValue("dateRange", [null, null]);
    };

    render() {
        return (
            <Form>
                <Col className="col-12" sm={12} md={6}>
                    <Field
                        component={DateRangeField}
                        hidePlaceholder
                        idForm={FORM_ID}
                        minDate={moment().add(-10, "years")}
                        maxDate={moment()}
                        name="dateRange"
                        dateFormat="dd/MM/yyyy"
                        selectsRange
                        showMonthYearDropdown
                        scrollableMonthYearDropdown
                        noEdit
                    />
                </Col>
                <Row>
                    <Col sm={12} md={6} className="col-12 col-no-pad-mobile" style={{ alignSelf: "flex-end" }}>
                        <Button bsStyle="outline" label="transactions.clean.filters" onClick={this.hadleClear} />
                    </Col>
                    <Col sm={12} md={6} className="col-12 col-no-pad-mobile" style={{ alignSelf: "flex-end" }}>
                        <Button bsStyle="primary" label="product.filters.filter" type="submit" block />
                    </Col>
                </Row>
            </Form>
        );
    }
}
const mapStateToProps = (state) => ({
    filters: transactionsSelectors.getFilters(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        validateOnChange: true,
        validateOnBlur: false,
        mapPropsToValues: (state) => ({
            dateFrom: state?.filters?.dateFrom || null,
            dateTo: state?.filters?.dateTo || null,
            dateRange: [state?.filters?.dateFrom || null, state?.filters?.dateTo || null],
        }),
        validationSchema: () =>
            Yup.lazy((values) =>
                Yup.object().shape({
                    dateFrom: values.dateTo
                        ? Yup.date()
                              .nullable()
                              .max(values.dateTo, i18n.get("accounts.movements.filters.from.error"))
                        : Yup.date().nullable(),
                    dateTo: values.dateFrom
                        ? Yup.date()
                              .nullable()
                              .min(values.dateFrom, i18n.get("accounts.movements.filters.to.error"))
                        : Yup.date().nullable(),
                }),
            ),
        handleSubmit: ({ ...filters }, formikBag) => {
            const { dispatch, isDesktop, onlyPendings, pendingDispatch, handleClickHideFilters } = formikBag.props;
            let dateFrom = filters?.dateRange[0];
            let dateTo = filters?.dateRange[1];
            if (filters.dateRange[0] === null) {
                dateFrom = moment().add(-1, "years");
            }
            if (filters.dateRange[1] === null) {
                dateTo = moment();
            }
            if (filters.dateRange[1] === null && filters.dateRange[0] === null) {
                dateFrom = moment().add(-1, "years");
                dateTo = moment();
            }
            if (isDesktop) {
                dispatch(
                    transactionsActions.loadListRequest(
                        { dateFrom, dateTo, pageNumber: 1 },
                        onlyPendings,
                        pendingDispatch,
                        false,
                        formikBag,
                    ),
                );
            } else {
                dispatch(
                    transactionsActions.setFilters({
                        filter: "period",
                        ...filters,
                    }),
                );
                dispatch(push(`/transactions/list/filters/results`));
            }
            handleClickHideFilters();
        },
    }),
)(PeriodFilter);
